import { CommonModule } from '@angular/common';
import { Component, ViewEncapsulation } from '@angular/core';
import { IconoirNavArrowDown } from '@ey-xd/motif-icon';
import {
  MotifChipModule,
  MotifDropdownModule,
  MotifIconModule,
  MotifTooltipModule,
} from '@ey-xd/ng-motif';
import {
  TranslatePipe,
  TranslateDirective,
  TranslateService,
} from '@ngx-translate/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'app-access-type',
  imports: [
    CommonModule,
    MotifIconModule,
    MotifChipModule,
    MotifDropdownModule,
    TranslatePipe,
    TranslateDirective,
    MotifTooltipModule,
  ],
  templateUrl: './access-type.component.html',
  styleUrl: './access-type.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class AccessTypeComponent implements ICellRendererAngularComp {
  selectedvalue: any = '';
  list: any = [];
  params: any;
  arrowDownIcon = IconoirNavArrowDown;
  isRole: boolean = false;
  disabled: boolean = false;

  constructor(private readonly translate: TranslateService) {}

  agInit(params: any): void {
    this.list = [];
    this.params = params;
    this.list = params.values;
    this.isRole = params.isRole;
    this.disabled = params.disabled || false;

    this.selectedvalue = !this.params.value
      ? { name: this.translate.instant('PleaseSelect'), id: -1 }
      : this.params.selectedValue;
  }

  refresh(params: any) {
    return true;
  }

  getChipHoverColor(): string {
    if (this.selectedvalue === 'Editor' || this.selectedvalue === 'Owner') {
      return '#27e35f';
    } else if (this.selectedvalue === 'Viewer') {
      return '#de9945';
    } else if (this.selectedvalue === 'Admin') {
      return '#ea011d';
    }
    return 'inherit';
  }

  getVariant() {
    let status = this.selectedvalue;
    switch (status) {
      case 'Viewer':
        return 'warning';
      case 'Editor':
        return 'success';
      case 'Admin':
        return 'error';
      case 'Owner':
        return 'success';
      default:
        return null;
    }
  }

  selectEvent(event) {
    this.selectedvalue = event;
    this.params.selectedData(this.selectedvalue, this.params);
  }
}
